import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

export const Logo = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity" 
      onClick={() => navigate("/")}
    >
      <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
        <Home className="w-5 h-5 text-primary-foreground" />
      </div>
      <div className="flex flex-col">
        <span className="text-xl font-bold leading-none">Maigida</span>
        <span className="text-xs text-muted-foreground">Find Your Perfect Stay</span>
      </div>
    </div>
  );
};